import { createI18n } from 'vue-i18n'
import { defaultLocale, languages } from '../localisation/index'

const i18n = createI18n({
  locale: defaultLocale,
  messages: Object.assign(languages)
})

export function setLocale(locale: string) {
  i18n.global.locale = locale // Dynamically set the locale
}

export default i18n
